// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p {
  margin-top: 0 !important;
}
.StepsFormClass select {
  border-radius: 13px !important;
}
.StepsFormClass input.form-control {
  margin: 0 !important;
  background: #ffffff;
  height: 36px;
  border: 2px solid #6d68aa;
  box-sizing: border-box;
  border-radius: 13px !important;
  font-family: "Montserrat", sans-serif !important;
  outline: none;
  padding: 0 18px;
}

.form-check {
  vertical-align: middle;
  /* line-height: 1 !important; */
}

.footer-buttons {
  padding-top: 15px;
  text-align: center;
  display: flex;
  justify-content: space-between;
  padding-top: 3rem !important;
}

.footer-buttons button,
button.step-button {
  border: 2px solid #6d68aa !important;
  color: #6d68aa !important;
  border-radius: 50rem;
  background: white !important;
  transition: all 0.4s ease-in-out;
  padding: 0.5rem 0.5rem;
  font-size: inherit;
  margin-left: 10px;
  margin-right: 10px;
  width: 150px;
}

.footer-buttons button:hover,
.footer-buttons button:active,
.footer-buttons button:focus,
button.step-button:hover,
button.step-button:active,
button.step-button:focus {
  background-color: #efefef !important;
  border: 2px solid #41c8ff;
}

button.step-button-fin {
  border: 2px solid #41c8ff;
  color: #4e5857 !important;
  border-radius: 50rem;
  background: transparent;
  transition: all 0.4s ease-in-out;
  padding: 0.5rem 0.5rem;
  font-size: inherit;
  margin-left: 10px;
  margin-right: 10px;
  font-weight: 600;
}
button.step-button-fin:hover,
button.step-button-fin:focus,
button.step-button-fin:active {
  background-color: #5ac2ad;
  border: 2px solid #41c8ff;
  color: white !important;
}
button.step-button {
  width: 350px !important;
}
.img-final-step {
  max-width: 150px;
}

.add-remove-button button {
  background: none;
  color: #4e5857 !important;
  border: none;
}

.check-style {
  background-color: #41c8ff;
  border: 2px solid #41c8ff;
  padding: 6px 25px 9px 25px;
  border-radius: 25px;
  color: white;
  font-weight: 600;
}

.check-style:hover {
  background-color: #6d68aa;
  border: 2px solid #41c8ff;
}

.check-style label {
  padding-top: 4px;
}
.check-style.check-style-disabled {
  background-color: white;
  border: 2px solid #c4c4c4;
  color: #c4c4c4;
}

input.form-control.input-file {
  border: 2px dotted #41c8ff !important;
  border-radius: 0;
  padding: 6px;
}

.upload-field {
  border: 3px #74bead;
  border-radius: 18px 0 0 18px;
  border-style: dashed;
  width: fit-content;
  vertical-align: middle;
}

.upload-field h6 {
  margin-bottom: 0;
}

button.upload-button {
  border-radius: 0px 18px 18px 0px;
  background-color: #74bead;
  color: white;
  border: 2px solid #74bead;
  outline: none;
}

button.upload-button:hover,
button.upload-button:active,
button.upload-button:focus {
  background-color: #b9ece0;
  border: 2px solid #b9ece0;
}

.img-final-step {
  max-width: 150px;
}

.step-button img {
  max-width: 25px;
}

.titleModalTresSteps {
  color: #ffffff;
  background-color: #5ac2ad;
}

.circleConfirm {
  color: #5ac2ad;
}
`, "",{"version":3,"sources":["webpack://./src/Views/Services/Components/StepForm/stylesSteps.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;AAC1B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;EAC9B,gDAAgD;EAChD,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;;EAEE,oCAAoC;EACpC,yBAAyB;EACzB,oBAAoB;EACpB,4BAA4B;EAC5B,gCAAgC;EAChC,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;;;;;;EAME,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,oBAAoB;EACpB,uBAAuB;EACvB,gCAAgC;EAChC,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;;;EAGE,yBAAyB;EACzB,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;EAC1B,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;EACzB,aAAa;AACf;;AAEA;;;EAGE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB","sourcesContent":["p {\r\n  margin-top: 0 !important;\r\n}\r\n.StepsFormClass select {\r\n  border-radius: 13px !important;\r\n}\r\n.StepsFormClass input.form-control {\r\n  margin: 0 !important;\r\n  background: #ffffff;\r\n  height: 36px;\r\n  border: 2px solid #6d68aa;\r\n  box-sizing: border-box;\r\n  border-radius: 13px !important;\r\n  font-family: \"Montserrat\", sans-serif !important;\r\n  outline: none;\r\n  padding: 0 18px;\r\n}\r\n\r\n.form-check {\r\n  vertical-align: middle;\r\n  /* line-height: 1 !important; */\r\n}\r\n\r\n.footer-buttons {\r\n  padding-top: 15px;\r\n  text-align: center;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  padding-top: 3rem !important;\r\n}\r\n\r\n.footer-buttons button,\r\nbutton.step-button {\r\n  border: 2px solid #6d68aa !important;\r\n  color: #6d68aa !important;\r\n  border-radius: 50rem;\r\n  background: white !important;\r\n  transition: all 0.4s ease-in-out;\r\n  padding: 0.5rem 0.5rem;\r\n  font-size: inherit;\r\n  margin-left: 10px;\r\n  margin-right: 10px;\r\n  width: 150px;\r\n}\r\n\r\n.footer-buttons button:hover,\r\n.footer-buttons button:active,\r\n.footer-buttons button:focus,\r\nbutton.step-button:hover,\r\nbutton.step-button:active,\r\nbutton.step-button:focus {\r\n  background-color: #efefef !important;\r\n  border: 2px solid #41c8ff;\r\n}\r\n\r\nbutton.step-button-fin {\r\n  border: 2px solid #41c8ff;\r\n  color: #4e5857 !important;\r\n  border-radius: 50rem;\r\n  background: transparent;\r\n  transition: all 0.4s ease-in-out;\r\n  padding: 0.5rem 0.5rem;\r\n  font-size: inherit;\r\n  margin-left: 10px;\r\n  margin-right: 10px;\r\n  font-weight: 600;\r\n}\r\nbutton.step-button-fin:hover,\r\nbutton.step-button-fin:focus,\r\nbutton.step-button-fin:active {\r\n  background-color: #5ac2ad;\r\n  border: 2px solid #41c8ff;\r\n  color: white !important;\r\n}\r\nbutton.step-button {\r\n  width: 350px !important;\r\n}\r\n.img-final-step {\r\n  max-width: 150px;\r\n}\r\n\r\n.add-remove-button button {\r\n  background: none;\r\n  color: #4e5857 !important;\r\n  border: none;\r\n}\r\n\r\n.check-style {\r\n  background-color: #41c8ff;\r\n  border: 2px solid #41c8ff;\r\n  padding: 6px 25px 9px 25px;\r\n  border-radius: 25px;\r\n  color: white;\r\n  font-weight: 600;\r\n}\r\n\r\n.check-style:hover {\r\n  background-color: #6d68aa;\r\n  border: 2px solid #41c8ff;\r\n}\r\n\r\n.check-style label {\r\n  padding-top: 4px;\r\n}\r\n.check-style.check-style-disabled {\r\n  background-color: white;\r\n  border: 2px solid #c4c4c4;\r\n  color: #c4c4c4;\r\n}\r\n\r\ninput.form-control.input-file {\r\n  border: 2px dotted #41c8ff !important;\r\n  border-radius: 0;\r\n  padding: 6px;\r\n}\r\n\r\n.upload-field {\r\n  border: 3px #74bead;\r\n  border-radius: 18px 0 0 18px;\r\n  border-style: dashed;\r\n  width: fit-content;\r\n  vertical-align: middle;\r\n}\r\n\r\n.upload-field h6 {\r\n  margin-bottom: 0;\r\n}\r\n\r\nbutton.upload-button {\r\n  border-radius: 0px 18px 18px 0px;\r\n  background-color: #74bead;\r\n  color: white;\r\n  border: 2px solid #74bead;\r\n  outline: none;\r\n}\r\n\r\nbutton.upload-button:hover,\r\nbutton.upload-button:active,\r\nbutton.upload-button:focus {\r\n  background-color: #b9ece0;\r\n  border: 2px solid #b9ece0;\r\n}\r\n\r\n.img-final-step {\r\n  max-width: 150px;\r\n}\r\n\r\n.step-button img {\r\n  max-width: 25px;\r\n}\r\n\r\n.titleModalTresSteps {\r\n  color: #ffffff;\r\n  background-color: #5ac2ad;\r\n}\r\n\r\n.circleConfirm {\r\n  color: #5ac2ad;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
